
import React, {Fragment} from "react";
import {connect} from "react-redux";
import {updatePage} from "../../actions/page";
import {DEFAULT_PER_PAGE} from "../../config";
import {displayErrors, normalizeEnum} from "../../libs/utils";
import {Button, Col, Pagination, Row, Space, Table, Tag, Tooltip} from "antd";
import {Link} from "react-router-dom";
import {StatusIndicator} from "../shared/Status";
import {DeleteOutlined, EyeOutlined, FilterOutlined} from "@ant-design/icons";
import UndoOutlined from "@ant-design/icons/lib/icons/UndoOutlined";
import SharedHostingServersTableFilter from "./SharedHostingServersTableFilter";
import {adminLoadSharedHostingServers} from "../../actions/network";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import SharedHostingServerModal from "./SharedHostingServerModal";

class SharedHostingServersTable extends React.Component {
    state = {
        pagination: { current: 1, pageSize: DEFAULT_PER_PAGE, total: 0, showSizeChanger: true },
        hostingServers: [],
        loadingHostingServers: true,
        filters: [],
        showFiltersModal: false,
        showBulkActionsModal: false,
        showSharedHostingServerModal: false
    }

    componentDidMount() {
        this.props.updatePage('Shared Hosting Servers');
        this.adminLoadSharedHostingServers();
    }

    adminLoadSharedHostingServers(page = null, per_page = null) {
        if(page == null) {
            page = this.state.pagination.current;
            per_page = this.state.pagination.pageSize;
        }

        this.setState({ loadingHostingServers: true });

        this.props.adminLoadSharedHostingServers(page, per_page, this.state.filters, (res) => {
            this.setState({ hostingServers: res.data.data, loadingHostingServers: false,
                pagination: { current: res.data.page, pageSize: res.data.per_page, total: res.data.total, showSizeChanger: true }});
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loadingHostingServers: false });
                displayErrors(err.response.data);
            }
        });
    }

    clearFilters() {
        this.setState({ filters: [] }, () => this.adminLoadSharedHostingServers());
    }

    setFilter(filter) {
        let filters = this.state.filters.filter(f => f.key !== filter.key);
        filters.push(filter);

        this.setState({ filters }, () => this.adminLoadSharedHostingServers());
    }

    removeFilter(item) {
        let filters = this.state.filters.filter(filter => filter.key !== item.key);
        this.setState({ filters }, () => this.adminLoadSharedHostingServers());
    }

    showFilters() {
        return this.state.filters.map((filter, i) => {
            let value;

            if (typeof filter.value === 'boolean') {
                if (filter.value) {
                    value = 'Yes';
                } else {
                    value = 'No';
                }
            } else {
                if (filter.visible !== null) {
                    value = filter.visible;
                } else {
                    value = normalizeEnum(filter.value);
                }
            }

            return <Tag key={i} closable onClose={() => this.removeFilter(filter)}>{filter.name}: {value}</Tag>;
        });
    }

    render() {
        const columns = [
            { title: 'Hostname', dataIndex: 'hostname', render: (item, record) => <Link to={'/network/shared-hosting-servers/' + record.guid}>{item.replace('.gateway.prioritynap.net', '')}</Link> },
            { title: 'IP address', dataIndex: 'ip_address', render: (item, record) => <Link to={'/network/shared-hosting-servers/' + record.guid}>{item}</Link> },
            { title: 'Status', dataIndex: 'status', render: (item) => <StatusIndicator status={item} el='badge' />},
            { title: 'Domains', dataIndex: 'domain_count', align: 'center'},
            { title: 'Accounts', dataIndex: 'account_count', align: 'center'},
            { title: 'Available', dataIndex: 'is_available', render: (item) => <StatusIndicator status={item ? 'YES' : 'NO'} el='badge' />},
            { title: '', align: 'right', render: (item, record) => <Link to={'/network/shared-hosting-servers/' + record.guid}><Button size='small' icon={<EyeOutlined />}>View</Button></Link>}
        ];

        return(
            <Fragment>
                {this.showFilters()}

                <Row justify='space-between' style={{marginBottom: '10px'}}>
                    <Col>
                        <Space>
                            <Button size='small' type='text' icon={<PlusOutlined />} onClick={() => this.setState({ showSharedHostingServerModal: true })}>Add Server</Button>
                            <Button size='small' type='text' icon={<FilterOutlined />} onClick={() => this.setState({ showFiltersModal: true })}>Filters</Button>
                            <Button size='small' type='text' disabled={this.state.filters.length === 0} onClick={() => this.clearFilters()} icon={<DeleteOutlined />}>Clear Filters</Button>
                        </Space>
                    </Col>
                    <Col>
                        <Space>
                            <Tooltip title='Reload' placement='left'><Button icon={<UndoOutlined />} size='small' type='circle' onClick={() => this.adminLoadSharedHostingServers()} /></Tooltip>
                            <Pagination onChange={(page, pageSize) => this.adminLoadSharedHostingServers(page, pageSize)} size='small' {...this.state.pagination} />
                        </Space>
                    </Col>
                </Row>

                <Table
                    columns={columns}
                    rowKey={(item) => item.guid}
                    dataSource={this.state.hostingServers}
                    loading={this.state.loadingHostingServers}
                    pagination={false}
                    footer={() => <Row justify='space-between'>
                        <Col />
                        <Col><Pagination onChange={(page, pageSize) => this.adminLoadSharedHostingServers(page, pageSize)} size='small' {...this.state.pagination} /></Col>
                    </Row>}
                />

                <SharedHostingServerModal
                    showModal={this.state.showSharedHostingServerModal}
                    reload={() => this.adminLoadSharedHostingServers()}
                    close={() => this.setState({ showSharedHostingServerModal: false})} />

                <SharedHostingServersTableFilter
                    showModal={this.state.showFiltersModal}
                    closeModal={() => this.setState({ showFiltersModal: false })}
                    onChange={(filter) => this.setFilter(filter) } />
            </Fragment>
        )
    }
}

export default connect(null, { updatePage, adminLoadSharedHostingServers })(SharedHostingServersTable);